import styled from 'styled-components'
import RentmoteBanner from '@/assets/rentmote-login-banner.png'
import { Outlet } from 'react-router'

const MainContainer = styled.main`
  position: relative;
  height: 100vh;
  overflow: hidden;
`

const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`

const StyledRightCell = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 40%; /* Ocupa el 40% del ancho de la pantalla */
  min-width: 350px; /* Ancho mínimo para pantallas pequeñas */
  height: 100%; /* Ocupa toda la altura de la pantalla */
  padding: 16px; /* Espaciado interno */
  overflow-y: auto; /* Scroll vertical si el contenido es demasiado alto */
  z-index: 2; /* El formulario está encima de la imagen */
`

export const LoginCircuitLayout = () => {
  return (
    <MainContainer>
      <BackgroundImage src={RentmoteBanner} alt="Banner" />
      <StyledRightCell>
        <Outlet />
      </StyledRightCell>
    </MainContainer>
  )
}